'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var configure = require('../lib/configure');

var toCamel = require('../lib/object-to-camel');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              _context.next = 3;
              return ky.post('key/list', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: options.searchParams
              }).json();

            case 3:
              res = _context.sent;
              return _context.abrupt("return", (res.Keys || []).map(function (k) {
                return toCamel(k);
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
});